import React from "react";
import FourPerspectiveAllocationPanel from "../components/FourPerspectiveAllocationPanel";
import { primaryOwner, fmtSignedMoney } from "../format";

export default function OwnershipTab({ ownership = [], unresolved }) {
  const owner = primaryOwner(ownership);
  return (
    <>
      <div className="rounded-card border border-card-bd bg-card p-5">
        <div className="text-[16px] font-semibold text-text">
          {owner ? `${owner.label} is the most likely owner, accounting for ${fmtSignedMoney(owner.deltaCost)} of the change.` : "Ownership not yet resolved."}
        </div>
        {unresolved && (
          <div className="mt-2 flex items-center gap-2 rounded-ctrl bg-warning-soft px-3 py-2 text-[13px] text-warning">
            <span className="inline-block rounded-full bg-warning" style={{ width: 8, height: 8 }} />
            {fmtSignedMoney(unresolved.deltaCost)} remains classified as {unresolved.label} and may require review.
          </div>
        )}
      </div>
      <FourPerspectiveAllocationPanel lenses={ownership} />
    </>
  );
}
